import React, { FC } from "react";
import dynamic from "next/dynamic";
import { twMerge } from "tailwind-merge";

export const icons = {
  facebook: dynamic(() => import("./icons/Facebook").then((i) => i.Facebook)),
  google: dynamic(() => import("./icons/Google").then((i) => i.Google)),
  close: dynamic(() => import("./icons/Close").then((i) => i.Close)),
  brush: dynamic(() => import("./icons/Brush").then((i) => i.Brush)),
  brush2: dynamic(() => import("./icons/Brush2").then((i) => i.Brush2)),
  arrowUp: dynamic(() => import("./icons/ArrowUp").then((i) => i.ArrowUp)),
  arrowDown: dynamic(() =>
    import("./icons/ArrowDown").then((i) => i.ArrowDown)
  ),
  arrowNext: dynamic(() =>
    import("./icons/ArrowNext").then((i) => i.ArrowNext)
  ),
  arrowBack: dynamic(() =>
    import("./icons/ArrowBack").then((i) => i.ArrowBack)
  ),
  arrowForward: dynamic(() =>
    import("./icons/ArrowForward").then((i) => i.ArrowForward)
  ),
  arrowPrev: dynamic(() =>
    import("./icons/ArrowPrev").then((i) => i.ArrowPrev)
  ),
  arrowTop: dynamic(() => import("./icons/ArrowTop").then((i) => i.ArrowTop)),
  arrowRight: dynamic(() =>
    import("./icons/ArrowRight").then((i) => i.ArrowRight)
  ),
  price: dynamic(() => import("./icons/Price").then((i) => i.Price)),
  play: dynamic(() => import("./icons/Play").then((i) => i.Play)),
  setting: dynamic(() => import("./icons/Setting").then((i) => i.Setting)),
  camera: dynamic(() => import("./icons/Camera").then((i) => i.Camera)),
  smile: dynamic(() => import("./icons/Smile").then((i) => i.Smile)),
  flag: dynamic(() => import("./icons/Flag").then((i) => i.Flag)),
  guard: dynamic(() => import("./icons/Guard").then((i) => i.Guard)),
  like: dynamic(() => import("./icons/Like").then((i) => i.Like)),
  warning: dynamic(() => import("./icons/Warning").then((i) => i.Warning)),
  success: dynamic(() => import("./icons/Success").then((i) => i.Success)),
  info: dynamic(() => import("./icons/Info").then((i) => i.Info)),
  error: dynamic(() => import("./icons/Error").then((i) => i.Error)),
  user: dynamic(() => import("./icons/User").then((i) => i.User)),
  globe: dynamic(() => import("./icons/Globe").then((i) => i.Globe)),
  ticket: dynamic(() => import("./icons/Ticket").then((i) => i.Ticket)),
  car: dynamic(() => import("./icons/Car").then((i) => i.Car)),
  bicycle: dynamic(() => import("./icons/Bicycle").then((i) => i.Bicycle)),
  check: dynamic(() => import("./icons/Check").then((i) => i.Check)),
  checkCircle: dynamic(() =>
    import("./icons/CheckCircle").then((i) => i.CheckCircle)
  ),
  closeCircle: dynamic(() =>
    import("./icons/CloseCircle").then((i) => i.CloseCircle)
  ),
  plus: dynamic(() => import("./icons/Plus").then((i) => i.Plus)),
  minus: dynamic(() => import("./icons/Minus").then((i) => i.Minus)),
  messenger: dynamic(() =>
    import("./icons/Messenger").then((i) => i.Messenger)
  ),
  calendar: dynamic(() => import("./icons/Calendar").then((i) => i.Calendar)),
  chat: dynamic(() => import("./icons/Chat").then((i) => i.Chat)),
  marker: dynamic(() => import("./icons/Marker").then((i) => i.Marker)),
  time: dynamic(() => import("./icons/Time").then((i) => i.Time)),
  lock: dynamic(() => import("./icons/Lock").then((i) => i.Lock)),
  list: dynamic(() => import("./icons/List").then((i) => i.List)),
  starOutline: dynamic(() =>
    import("./icons/StarOutline").then((i) => i.StarOutline)
  ),
  star: dynamic(() => import("./icons/Star").then((i) => i.Star)),
  share: dynamic(() => import("./icons/Share").then((i) => i.Share)),
  shareNew: dynamic(() => import("./icons/ShareNew").then((i) => i.ShareNew)),
  print: dynamic(() => import("./icons/Print").then((i) => i.Print)),
  archive: dynamic(() => import("./icons/Archive").then((i) => i.Archive)),
  announce: dynamic(() => import("./icons/Announce").then((i) => i.Announce)),
  important: dynamic(() =>
    import("./icons/Important").then((i) => i.Important)
  ),
  template: dynamic(() =>
    import("./icons/TemplateIcon").then((i) => i.TemplateIcon)
  ),
  tableOfContent: dynamic(() =>
    import("./icons/TableOfContent").then((i) => i.TableOfContent)
  ),
  checkBold: dynamic(() =>
    import("./icons/CheckBoldIcon").then((i) => i.CheckBoldIcon)
  ),
  twitter: dynamic(() => import("./icons/Twitter").then((i) => i.Twitter)),
  instagram: dynamic(() =>
    import("./icons/Instagram").then((i) => i.Instagram)
  ),
  facebookRound: dynamic(() =>
    import("./icons/FacebookRound").then((i) => i.FacebookRound)
  ),
  copy: dynamic(() => import("./icons/Copy").then((i) => i.Copy)),
  whatsapp: dynamic(() => import("./icons/Whatsapp").then((i) => i.Whatsapp)),
  email: dynamic(() => import("./icons/Email").then((i) => i.Email)),
  xtwitter: dynamic(() => import("./icons/XTwitter").then((i) => i.XTwitter)),
  faqDocument: dynamic(() =>
    import("./icons/FaqDocument").then((i) => i.FaqDocument)
  ),
  lostCharacter: dynamic(() =>
    import("./icons/LostCharacter").then((i) => i.LostCharacter)
  ),
  verifiedGlyph: dynamic(() =>
    import("./icons/VerifiedGlyph").then((i) => i.VerifiedGlyph)
  ),
  checkBlueFilled: dynamic(() =>
    import("./icons/CheckBlueFilled").then((i) => i.CheckBlueFilled)
  ),
  lens: dynamic(() => import("./icons/Lens").then((i) => i.Lens)),
  arrow: dynamic(() => import("./icons/Arrow").then((i) => i.Arrow)),
  people: dynamic(() => import("./icons/People").then((i) => i.People)),
  talk: dynamic(() => import("./icons/Talk").then((i) => i.Talk)),
  value: dynamic(() => import("./icons/Value").then((i) => i.Value)),
  envelope: dynamic(() => import("./icons/Envelope").then((i) => i.Envelope)),
  x: dynamic(() => import("./icons/X").then((i) => i.X)),
  zoom: dynamic(() => import("./icons/Zoom").then((i) => i.Zoom)),
  babySeat: dynamic(() => import("./icons/Zoom").then((i) => i.Zoom)),
  pin: dynamic(() => import("./icons/Pin").then((i) => i.Pin)),
  suitcase: dynamic(() => import("./icons/Suitcase").then((i) => i.Suitcase)),
  transfer: dynamic(() => import("./icons/Transfer").then((i) => i.Transfer)),
  childSeat: dynamic(() =>
    import("./icons/ChildSeat").then((i) => i.ChildSeat)
  ),
  childBooster: dynamic(() =>
    import("./icons/ChildBooster").then((i) => i.ChildBooster)
  ),
};

export type IconType = keyof typeof icons;

const sizes = {
  xs: "h-4 w-4",
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
  none: "",
};

export type IconSize = keyof typeof sizes;

interface IconProps {
  icon: IconType;
  size?: IconSize;
  className?: string;
  fill?: string;
  title?: string;
  onClick?: () => void;
  strokeWidth?: number;
}

const Icon: FC<IconProps> = ({
  icon,
  className,
  onClick,
  size = "md",
  fill = "none",
  title = "GoWithGuide",
  strokeWidth = 1,
}) => {
  const Component = icons[icon];
  return (
    <Component
      className={twMerge(`${sizes[size]}`, className)}
      onClick={onClick}
      fill={fill}
      title={title}
      strokeWidth={strokeWidth}
    />
  );
};

export default Icon;
